import { groupBy, clone, cloneDeep } from "lodash-es";
import { peopleNameSort } from "@/utils/personNameSort";
import { FipaEventStatus } from "@/types/event/event";
export const EventParticipantProps = {
    event: {
        type: Object,
        required: true
    },
    registrations: {
        type: Array,
        required: true
    }
};
export function useParticipantsHelper(event) {
    function filterEntriesOutByResolution(registrations) {
        return cloneDeep(registrations).reduce((regs, r) => {
            r.entries = r.entries.filter(entry => {
                return ["participated", "void"].includes(entry.resolution);
            });
            if (r.entries.length)
                regs.push(r);
            return regs;
        }, []);
    }
    function registrationStateColor(item, competitionId) {
        if (competitionId) {
            return item.entries.some(e => e.competition.id == competitionId && e.paymentStatus != "PAID")
                ? "bg-strong"
                : "";
        }
        else if (item.entries.some(e => e.paymentStatus != "PAID")) {
            return "bg-strong";
        }
    }
    function registrationsByClass(competitionId, allRegistrations) {
        const registrations = [];
        let rawRegistrations = clone(allRegistrations);
        if (event.value.status == FipaEventStatus.ResultsPublished) {
            rawRegistrations = filterEntriesOutByResolution(rawRegistrations);
        }
        rawRegistrations.forEach(r => {
            if (r.entries.some(entry => entry.competition.id == competitionId)) {
                const reg = JSON.parse(JSON.stringify(r));
                const entry = reg.entries.find(e => e.competition.id == competitionId);
                reg.registrationConfirmedAt = entry.registrationConfirmedAt;
                reg.competitionId = competitionId;
                if (event.value.discipline.name != "vaulting") {
                    reg.teamName = entry.teamName ?? reg.teamName;
                }
                registrations.push(reg);
            }
        });
        const athleteNames = registrations.map((reg, i) => {
            return {
                firstName: reg.athletes[0].firstName,
                lastName: reg.athletes[0].lastName,
                index: i
            };
        });
        return peopleNameSort(athleteNames).map(athlete => {
            return registrations[athlete.index];
        });
    }
    function teamsByClass(competitionId, allRegistrations) {
        const regs = registrationsByClass(competitionId, allRegistrations).reduce((arr, r) => {
            const entry = r.entries.find(x => x.competition.id == competitionId);
            if (entry) {
                arr.push({
                    athletes: r.athletes,
                    registrationPeople: r.registrationPeople,
                    horses: r.horses,
                    registrationHorses: r.registrationHorses,
                    teamName: entry.teamName
                });
            }
            return arr;
        }, []);
        return Object.entries(groupBy(regs, "teamName")).reduce((arr, [teamName, teams]) => {
            if (teamName != "null") {
                arr.push([
                    teamName,
                    teams.map(team => {
                        team.athletes = peopleNameSort(team.athletes);
                        return team;
                    })
                ]);
            }
            return arr;
        }, []);
    }
    return {
        filterEntriesOutByResolution,
        registrationStateColor,
        registrationsByClass,
        teamsByClass
    };
}
